import { Provider } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import { useEffect } from 'react';
import { store } from './redux/store';
import Routes from './routes/Routes';
import 'react-toastify/dist/ReactToastify.css';
import { BrandingProvider, useBranding } from './contexts/BrandingContext';
import Loader from './components/Loader/Loader';

function AppContent() {
  const { loading, error, branding } = useBranding();

  useEffect(() => {
    if (branding) {
      // Update document title
      document.title = branding.appTitle;

      // Update favicon
      const favicon = document.querySelector("link[rel='icon']") || document.createElement('link');
      favicon.type = 'image/x-icon';
      favicon.rel = 'icon';
      favicon.href = branding.faviconPath;
      document.head.appendChild(favicon);

      // Apply theme colors as CSS variables
      const colorVariables = branding.colors;
      Object.keys(colorVariables).forEach((key) => {
        const cssVariableName = `--${key.replace(/([A-Z])/g, '-$1').toLowerCase()}-color`; // Convert camelCase to kebab-case
        document.documentElement.style.setProperty(cssVariableName, colorVariables[key]);
      });
    }
  }, [branding]);

  if (loading) return <Loader />;
  if (error) return <div>Error: {error}</div>;

  return (
    <Provider store={store}>
      <ToastContainer />
      <Routes />
    </Provider>
  );
}

function App() {
  return (
    <BrandingProvider>
      <AppContent />
    </BrandingProvider>
  );
}

export default App;